import "./UtilitiesPowerGeneration.module.css";
import Header from "@/reusable_sections/Header";
import PageHeader from "./sections/PageHeader";
import DirectAnswerBlock from "./sections/DirectAnswerBlock";
import TheUtilityEnvironmentProblem from "./sections/TheUtilityEnvironmentProblem";
import WhatGetsLabeledInUtilitiesPowerGeneration from "./sections/WhatGetsLabeledInUtilitiesPowerGeneration";
import BuiltToSurviveTheEnvironment from "./sections/BuiltToSurviveTheEnvironment";
import StandardsHighVoltageSafety from "./sections/StandardsHighVoltageSafety";
import HowToOrder from "./sections/HowToOrder";
import Faq from "./sections/Faq";
import ClosingCta from "./sections/ClosingCta";
import Footer from "@/reusable_sections/Footer";
export default function UtilitiesPowerGenerationPage() {
  return <div>
      <Header />
      <PageHeader />
      <DirectAnswerBlock />
      <TheUtilityEnvironmentProblem />
      <WhatGetsLabeledInUtilitiesPowerGeneration />
      <BuiltToSurviveTheEnvironment />
      <StandardsHighVoltageSafety />
      <HowToOrder />
      <Faq />
      <ClosingCta />
      <Footer />
    </div>;
}